import {IActionBase} from "./IActionBase";
import {Component} from "react";
import {ActionsManager} from "./actionsManager";
import {store} from "../../redux/storeConfig/store";
import {sendApplyooComponentsNotification} from "../infrastructure/useApplyooComponent";

export class action_AP_DuplicateSingleRow extends Component implements IActionBase {

    actionCode = "action_AP_DuplicateSingleRow";
    actionName = "Duplicate Single Row";

    Execute = (prmActionParameters:any,prmActionsManager:ActionsManager, prmElementObj?:any)=> {

        var queryName = "";

        if (!!prmActionParameters
            && !!prmActionParameters.QueryName) {
            queryName = prmActionParameters.QueryName;
        }

        if (!!prmActionParameters.LstActionsBeforeDuplicate && prmActionParameters.LstActionsBeforeDuplicate.length > 0) {
            prmActionsManager?.executeActions(prmActionParameters.LstActionsBeforeDuplicate, prmElementObj.ElementObj)

        }

        store.dispatch({type:'DUPLICATE_QUERY_DATA', queryName: queryName});

        sendApplyooComponentsNotification("ApplyooGlobal", "ProjectFrameContainer", {command: "changeUrlParams", dicNewUrlParams:{'rowID': '-1'}})

        if (!!prmActionParameters.LstActionsAfterDuplicate && prmActionParameters.LstActionsAfterDuplicate.length > 0) {
            prmActionsManager?.executeActions(prmActionParameters.LstActionsAfterDuplicate, prmElementObj.ElementObj)
        }

        if (!!prmActionParameters
            && !!prmActionParameters?.callbackFunction){
            prmActionParameters.callbackFunction();
        }
    }

}